<ng-container>
  <fin-loyalty-section-navigation [mobile]="true" />
  <div>
    <div [class.hero-background]="showHeroBackground" [class.hero-gold]="showGoldHeroBackground">
      <div
        class="grid-col-12 pr-large-b pr-medium-t padding-left-gutter padding-right-gutter grid-max-width center ng-star-inserted"
      >
        <div
          class="col-1-12 font-heading-2 nordic-blue-900-text text-icon-primary font-headline-small"
          [class.hero-greeting]="showHeroBackground"
          data-testid="loyalty-view-page-title"
        >
          {{ pageTitle }}
        </div>
      </div>
      <div class="grid-col-12 grid-max-width padding-left-gutter padding-right-gutter center">
        <div class="col-1-12 md-col-1-3 dn-laptop-down">
          @if (showPlusCard) {
            <fcom-plus-card class="ms-xxlarge-b" />
          }

          <fin-loyalty-section-navigation />

          @if (showAnnouncementCard) {
            <fin-announcement-card class="ms-xxlarge-t block" />
          }

          <ng-content select="[contentLeft]" />
        </div>
        <div class="col-1-12 md-col-4-12">
          <ng-content />
        </div>
      </div>
    </div>
    @if (constrainBenefitBanner) {
      <div>
        <div class="grid-col-12 grid-max-width padding-left-gutter padding-right-gutter center">
          <div class="col-1-12 md-col-1-3 dn-laptop-down"></div>
          <div class="col-1-12 md-col-4-12 ms-large-t">
            <ng-container *ngTemplateOutlet="benefitBannerContent" />
          </div>
        </div>
      </div>
    } @else {
      <div class="ms-large-t">
        <ng-container *ngTemplateOutlet="benefitBannerContent" />
      </div>
    }
    <ng-template #benefitBannerContent>
      <ng-content select="[benefitBanner]" />
    </ng-template>
  </div>
</ng-container>
